import { render, staticRenderFns } from "./doctors.vue?vue&type=template&id=4660e2a8&scoped=true&"
import script from "./doctors.vue?vue&type=script&lang=js&"
export * from "./doctors.vue?vue&type=script&lang=js&"
import style0 from "./doctors.vue?vue&type=style&index=0&id=4660e2a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4660e2a8",
  null
  
)

export default component.exports